import type { CellContext } from '@tanstack/react-table'
import { RotateCcwIcon } from 'lucide-react'

import {
  ProcessButton,
  type Statement,
  type StatementStatus,
  StatementStatusBadge,
  VerifyingBadge,
} from '@/modules/projects'
import {
  hasStatementFailed,
  isStatementHeldForTeam,
} from '@/modules/projects/status'

export const StatusCell = (cell: CellContext<Statement, string>) => {
  const statement = cell.row.original

  return (
    <div className="flex gap-1">
      {isStatementHeldForTeam(statement) ? (
        <VerifyingBadge />
      ) : (
        <StatementStatusBadge status={cell.getValue() as StatementStatus} />
      )}{' '}
      {hasStatementFailed(statement) && (
        <div className="flex items-center text-xs text-gray-500">
          <ProcessButton
            table={cell.table}
            statementsToProcess={[statement]}
            theme="ghost"
            size="xs"
            icon={RotateCcwIcon}
            title="Retry statement"
            isIcon
            validationBehaviour="hidden"
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </div>
  )
}
